module.exports = __webpack_public_path__ + "img/who-covered.68112f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/who-covered.jpg
// module id = ./assets/img/who-covered.jpg
// module chunks = 2 3 4 5 6